import * as React from 'react';
import * as intl from "react-intl-universal";
import { Alert } from 'antd';
import ModalHelper, { Dialog } from 'common/components/ModalHelper';
import Form from 'common/components/Form';

interface iProps {
    className?: string;
    extension?: Function;
    onSubmit?: Function;
}

export default class Feedback extends React.Component<iProps> {
    form: any;

    /**
     * 获取表单组件
     */
    getContent = () => {
        let config = {
            layout: 'vertical',
            items: [{
                key: 'title',
                type: 'text',
                placeholder: intl.get('Hint.Input', { field: intl.get('Global.Title') }),
                label: intl.get('Global.Title'),
                validators: ['required'],
                filter: (value: any) => value.substring(0, 20)
            }, {
                key: 'content',
                type: 'richText',
                isRelativeUrl: true,
                enabledImage: true,
                format: 'html',
                className: 'middle',
                encode: true,
                hasFeedback: false,
                label: intl.get('Global.Suggestion'),
                validators: ['required']
            }]
        };
        return (
            <div>
                <Alert message={intl.get('Hint.SendYourOpinion')} showIcon/>
                <Form config={config} extension={(form: any) => this.form = form}/>
            </div>
        );
    };

    /**
     * 提交反馈
     */
    submitHandle = () => {
        if (this.form) {
            this.form.validateFields((err: any, values: any) => {
                if (err) return;
                this.props.onSubmit(values);
            });
        }
    };

    /**
     * 打开反馈模态框
     */
    openClickHandler = async () => {
        await ModalHelper.show({
            Dialog: Dialog,
            config: {
                width: 750,
                title: intl.get('Hint.ThxForYourOpinion'),
                content: this.getContent(),
                onOK: this.submitHandle,
                footer: 'all'
            }
        });
    };

    render() {
        const { className, extension } = this.props;
        extension && extension(this.form);
        return (
            <span className={className} onClick={this.openClickHandler}>
                <img src={window.config.img_file(`/images/icons/message.png`)} alt='message'/>
            </span>
        );
    }
}
